module.exports = __webpack_public_path__ + "static/media/tim.9e6c11f0.jpg";